import { faExclamation } from "@fortawesome/pro-solid-svg-icons";

import { UISubscriptionStatus } from "common/types";
import { Optional } from "common/utils/types";

import Status from "client/common/components/content/Status";

import { SubscriptionAddressIssue } from "../types";
import { shouldShowSubscriptionAddressAlert } from "../utils";

type SubscriptionAddressWarningIconProps = {
  subscription: {
    visible_status: UISubscriptionStatus;
    shipping_address: Optional<SubscriptionAddressIssue>;
  };
};

/**
 * Points at the shipping address field rather than the Autoship as a whole, so the client can
 * see which one needs attention. Still shown when the banner describes a payment problem,
 * because payment takes that slot first.
 */
const SubscriptionAddressWarningIcon = ({ subscription }: SubscriptionAddressWarningIconProps) => {
  if (!shouldShowSubscriptionAddressAlert(subscription)) {
    return null;
  }
  return <Status.Icon color="danger" icon={faExclamation} />;
};

export default SubscriptionAddressWarningIcon;
